<div [ngClass]="size" [class.hidden-ad]="hidden" #ad [id]="bannerId" [style.min-height]="minHeight + 'px'" [style.min-width]="minWidth + 'px'"></div>

